import React, { useContext, useState } from 'react'
import AuthController from './controllers/AuthController'
import AppContext from './appContext'
import { bind, onEnter, wrapLoader } from './wrapper'
import { useSearchParams } from 'react-router-dom'
import AppState from './controllers/AppState'
import { useValidation } from './validation'
import AuthLayout from './components/AuthLayout'

const ResetPassword: React.FC<{ setInitial: (state: AppState) => void }> = (props) => {
    const app = useContext(AppContext)

    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState('')
    const [searchParams, _] = useSearchParams()

    const validation = useValidation({
        passwordRequired: () => password.length > 0,
        confirmPasswordRequired: () => confirmPassword === password
    })

    function reset () {
        const token = searchParams.get('token')

        if (!validation.validate()) { return }

        wrapLoader(app, AuthController.resetPassword({
            password,
            token: token ?? ''
        }), data => {
            if (data) {
                window.location.href = '/'
            } else {
                setError('token_expired')
            }
        })
    }

    return (
        <AuthLayout>
            <div className="text-center">
                <img src="/images/at-mark.png" alt="" className="mx-auto h-24 w-auto"/>
                <h2 className="mt-5 font-display text-4xl font-semibold text-secondary-600">Reset Password</h2>
            </div>

            <div className="mt-8 space-y-5" onKeyUp={onEnter(reset)}>
                <div>
                    <label className="mb-1 block text-base text-gray-500">Password</label>
                    <input className="w-full rounded-lg bg-gray-100 px-4 py-3 outline-none focus:ring-2 focus:ring-primary-400"
                        type="password" autoFocus {...bind(password, setPassword)}/>
                    {!validation.rules.passwordRequired &&
                        <div className="mt-1 text-sm text-error-500">Password is required</div>}
                </div>

                <div>
                    <label className="mb-1 block text-base text-gray-500">Confirm Password</label>
                    <input className="w-full rounded-lg bg-gray-100 px-4 py-3 outline-none focus:ring-2 focus:ring-primary-400"
                        type="password" {...bind(confirmPassword, setConfirmPassword)}/>
                    {!validation.rules.confirmPasswordRequired &&
                        <div className="mt-1 text-sm text-error-500">Passwords do not match</div>}
                </div>

                <button className="w-full rounded-lg bg-success-600 py-3 text-2xl tracking-wide text-white shadow-md transition hover:bg-success-700"
                    onClick={reset}>Reset Password
                </button>

                {error && <div className="text-center text-sm text-error-500">This reset link has expired. Please request a new one.</div>}
            </div>
        </AuthLayout>
    )
}

export default ResetPassword
